import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_INDIVIDUALS,
	STR_GROUPS,
	STR_CREATE_NEW_CONTACT,
	STR_INVALID_NAME,
	STR_INVALID_PHONE,
	STR_INVALID_WHATSAPP_NUMBER,
	STR_SUCCESS,
	STR_NAME,
	STR_PHONE_NUMBER,
	STR_WHATSAPP_NUMBER,
	STR_OPTIONAL,
	STR_SUBMIT,
	STR_ENTER_DETAILS,
	STR_UPLOAD_FILE,
	STR_EXCEL_FILE_HELPER_TEXT,
	STR_FILE,
	STR_INVALID_FILE
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAdd, MdDelete, MdInfoOutline, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup } from 'react-icons/md';
import { GiPayMoney } from "react-icons/gi";
import { TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";

export default function View({ data, callback }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [name, setName] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [whatsAppNumber, setWhatsAppNumber] = useState("");
	const [contactGroupId, setContactGroupId] = useState([]);
	const [howToAdd, setHowToAdd] = useState('individual');

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getAllContactGroups(),
		])
		setReady(true);
	}

	function addGroup() {
		setContactGroupId(_prev => {
			const _new = [..._prev, ''];

			return _new;
		})
	}

	function handleGroupChange(_index, _value){
		setContactGroupId(_prev => {
			const _new = [..._prev];
			
			if(Number(_value)) {
				_new[_index] = Number(_value);
			}

			return _new;
		})
	}

	function deleteGroup(_index){
		setContactGroupId(_prev => {
			const _new = [..._prev];
			
			_new.splice(_index, 1);

			return _new;
		})
	}

	function cleanGroups(_raw) {
		const _cleaned = [];

		for (const _item of _raw) {
			if(Number(_item)) {
				_cleaned.push(Number(_item));
			}
		}

		return [...new Set(_cleaned)];
	}

	function resetFields() {
		setName("");
		setPhoneNumber("");
		setWhatsAppNumber("");
		setContactGroupId([]);
	}

	async function uploadContactsSheet() {
		let contactsSheet = null;

		try {
			contactsSheet = document.getElementById('_contactsSheet').files[0];
		} catch (error) {
			
		}

		if(contactsSheet) {
			setLoading(true);
			await callApi('upload-contacts-sheet', { contactsSheet }).then(response => {
				if(response.status === 1) {
					appContext.tellMessage(STR_SUCCESS[appContext.language]);
					appContext.getAllContacts();
					appContext.getAllContactGroups();
					appContext.navBack();
				} else {
					appContext.tellError(response.msg);
				}
			})
			setLoading(false);
		} else {
			appContext.tellError(STR_INVALID_FILE[appContext.language]);
		}
	}

	async function createContact() {
		if(name && name.trim().length > 0) {
			if(phoneNumber && phoneNumber.trim().length === 12) {
				if((whatsAppNumber && whatsAppNumber.trim().length === 12) || !whatsAppNumber) {
					setLoading(true);
					await callApi(
						"create-contact",
						{
							name,
							phoneNumber,
							whatsAppNumber,
							contactGroupId: JSON.stringify(cleanGroups(contactGroupId)),
						}
					).then((response) => {
						if(response.status === 1) {
							appContext.tellMessage(STR_SUCCESS[appContext.language]);
							appContext.getAllContacts();
							resetFields();
						} else {
							appContext.tellError(response.msg);
						}
					})
					setLoading(false);
				} else {
					appContext.tellError(STR_INVALID_WHATSAPP_NUMBER[appContext.language]);
				}
			} else {
				appContext.tellError(STR_INVALID_PHONE[appContext.language]);
			}
		} else {
			appContext.tellError(STR_INVALID_NAME[appContext.language]);
		}
	}

	async function editContact() {
		if(name && name.trim().length > 0) {
			if(phoneNumber && phoneNumber.trim().length === 12) {
				if((whatsAppNumber && whatsAppNumber.trim().length === 12) || !whatsAppNumber) {
					setLoading(true);
					await callApi(
						"edit-contact",
						{
							id: data.id,
							name,
							phoneNumber,
							whatsAppNumber,
							contactGroupId: JSON.stringify(cleanGroups(contactGroupId)),
						}
					).then((response) => {
						if(response.status === 1) {
							appContext.tellMessage(STR_SUCCESS[appContext.language]);
							appContext.getAllContacts();

							if(callback) {
								callback();
							}
						} else {
							appContext.tellError(response.msg);
						}
					})
					setLoading(false);
				} else {
					appContext.tellError(STR_INVALID_WHATSAPP_NUMBER[appContext.language]);
				}
			} else {
				appContext.tellError(STR_INVALID_PHONE[appContext.language]);
			}
		} else {
			appContext.tellError(STR_INVALID_NAME[appContext.language]);
		}
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		if(phoneNumber) {
			setWhatsAppNumber(phoneNumber);
		}
	}, [ phoneNumber ])

	useEffect(() => {
		if(data) {
			setName(data.name);
			setPhoneNumber(data.phoneNumber);
			setWhatsAppNumber(data.whatsAppNumber);
			setContactGroupId(JSON.parse(data.contactGroupId));
		}
	}, [ data ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
	}, [ loading ])

	if (ready) {
		return (
			<div
				className="container"
			>
			
				<div className="row">

					{
						(!data) ?
						<div className="col-md-12">
							<h6
								className="mSectionTitle"
							>
								{STR_CREATE_NEW_CONTACT[appContext.language]}
							</h6>
							
						</div>
						:""
					}

					{
						(!data) ?						
						<div 
							className="col-md-12 mt-2 mb-2"
							style={{
								paddingBottom: "10px",
								borderBottom: "1px solid var(--secondaryColor)"
							}}
						>
							<div className="d-flex justify-content-between">
								<button
									className={(howToAdd === 'individual') ? 'btn btn-dark btn-sm' : 'btn btn-sm'}
									onClick={() => setHowToAdd('individual')}
									style={{
										width: "50%",
									}}
								>
									{STR_ENTER_DETAILS[appContext.language]}
								</button>

								<button
									className={(howToAdd === 'sheet') ? 'btn btn-dark btn-sm' : 'btn btn-sm'}
									onClick={() => setHowToAdd('sheet')}
									style={{
										width: "50%",
									}}
								>
									{STR_UPLOAD_FILE[appContext.language]}
								</button>
							</div>
						</div>
						:""
					}

					{
						(howToAdd === 'sheet') ?
						<div className="col-md-12">
							<div className="mb-3 mt-3">
								<h6
									style={{
										fontSize: "18px"
									}}
								>
									{STR_EXCEL_FILE_HELPER_TEXT[appContext.language]}
								</h6>
							</div>

							<div className="mb-3 mt-3">
								<label className="form-label">{STR_FILE[appContext.language]}</label>
								<input
									type="file"
  								className="form-control"
  								accept=".xls,.xlsx"
									id="_contactsSheet"
								/>
							</div>

							<div className="mb-3 mt-3 text-end">
								<button
									className="btn btn-rounded bg-secondary btn-padded"
									onClick={uploadContactsSheet}
								>
									{STR_SUBMIT[appContext.language]}
								</button>
							</div>

						</div>
						:""
					}

					{
						(howToAdd === 'individual') ?
						<div className="col-md-12">
							<div className="mb-3 mt-3">
								<label className="form-label">{STR_NAME[appContext.language]}</label>
								<input
									className="form-control"
									value={name}
									onChange={(e) => setName(e.target.value)}
									maxLength={20}
								/>
								<div className="text-end">
									<h6
										className="font-semi-bold"
										style={{
											fontSize: "14px"
										}}
									>
										{name.length}/20
									</h6>
								</div>
							</div>

							<div className="mb-3 mt-3">
								<label className="form-label d-block">{STR_GROUPS[appContext.language]}</label>
								{
									contactGroupId.map((item, i) => {
										return (
											<div 
												className="d-flex mt-1"
												key={i}
											>
												<select
													className="form-control align-self-center"
													style={{
														flexGrow: "1",
													}}
													value={item}
													onChange={(e) => handleGroupChange(i, e.target.value)}
												>
													<option value=""></option>
													{
														(appContext.allContactGroups && appContext.allContactGroups.length > 0) ?
														appContext.allContactGroups.map((item, i) => {
															return (
																<option key={i} value={item.id}>{item.name}</option>
															)
														})
														:""
													}
												</select>

												<MdDelete
													className="align-self-center text-danger"
													size={32}
													onClick={() => deleteGroup(i)}
													style={{
														cursor: "pointer",
													}}
												/>
											</div>
										)
									})
								}
								<button
									className="btn btn-secondary btn-sm mt-2"
									onClick={addGroup}
								>
									<MdAdd size={24}/>
								</button>
							</div>

							<div className="mb-3 mt-3">
								<label className="form-label">{STR_PHONE_NUMBER[appContext.language]}</label>
								<input
									className="form-control"
									value={phoneNumber}
									onChange={(e) => setPhoneNumber(String(Number(e.target.value) || ''))}
									placeholder="255XXXXXXXXX"
									maxLength={12}
								/>
							</div>

							<div className="mb-3 mt-3">
								<label className="form-label">{STR_WHATSAPP_NUMBER[appContext.language]}</label>
								<input
									className="form-control"
									value={whatsAppNumber}
									onChange={(e) => setWhatsAppNumber(String(Number(e.target.value) || ''))}
									placeholder="255XXXXXXXXX"
									maxLength={12}
								/>
								<div className="form-text">
									{STR_OPTIONAL[appContext.language]}
								</div>
							</div>

							<div className="mb-3 mt-3 text-end">
								{
									(data) ?
									<button
										className="btn btn-rounded bg-secondary btn-padded"
										onClick={editContact}
									>
										{STR_SUBMIT[appContext.language]}
									</button>
									:
									<button
										className="btn btn-rounded bg-secondary btn-padded"
										onClick={createContact}
									>
										{STR_SUBMIT[appContext.language]}
									</button>
								}
							</div>

						</div>
						:""
					}
				</div>
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}